<template>
    <div class=" d-flex justify-content-center align-items-center">

        <form v-on:keyup.enter="checkThenSend" class="editForm shadow">
            <div>
                <div>
                    <label for="editName">Nom : </label>
                    <input id="editName" type="text" placeholder="Nom" v-model="name">
                </div>
                <div>
                    <label for="editEmail">Email : </label>
                    <input id="editEmail" type="text" placeholder="Email" v-model="email">
                </div>
            </div>
            <div class="error row" v-if="errors.length">
                <ul>
                    <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                </ul>
            </div>
            <div v-if="!pending" class="btn row btn-outline-success" v-on:click="checkThenSend">Modifier</div>
        </form>
    </div>
</template>

<script>

    const axios = require('axios');

    export default {
        name: "EditInformations",
        data() {
            return {
                pending: false,
                errors: [],
                login: '',
                name: '',
                email: '',
                
            }
        },
        created: function() {
            this.login = localStorage.login;
            this.name = localStorage.name;
            if (localStorage.email !== 'null') {
                this.email = localStorage.email;
            }
        },
        methods: {
            sendUpdate: function() {
                var data = {
                    login: this.login,
                    name: this.name,
                    email: this.email,
                    rate: null,
                    role: null,
                    status: null,
                };

                axios.put(this.$store.state.apiUrl + 'user/update/' + localStorage.id, data, {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                    })
                    .then(response => (this.checkResponse(response)))
                    .catch((e) => {
                        this.printError(e);
                    });
            },
            checkThenSend: function() {
                this.errors = [];
                this.pending = true;
                const regex = new RegExp('^[a-z0-9._-]+[@][a-z0-9._-]{2,}[.][a-z]{2,4}$');
                if (this.email && !regex.test(this.email)) {
                    this.errors.push("Le format d'email renseigné n'est pas valide");
                    this.pending = false;
                } else {
                    this.sendUpdate();
                }
            },
            checkResponse: function(response) {
                if (response.status == 200) {
                    localStorage.login = response.data.login;
                    localStorage.name = response.data.name;
                    localStorage.email = response.data.email;
                    this.printSuccess();
                }
                this.pending = false;

            },
            printError: function(e) {
                this.pending=false;
                console.log(e);
                this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
                    position: 'bottom-center',
                    theme: 'outline'
                }).goAway(2000);
            },
            printSuccess: function() {
                this.$toasted.show("Informations modifié", {
                    position: 'bottom-center',
                    theme: 'outline'
                }).goAway(2000);
            }
        }
    };
</script>

<style scoped>
    #banner {
        width: 100%;
        display: table;
    }

    #banner img {
        margin-bottom: 4%;
        height: 10em;
    }

    #banner span {
        font-weight: bold;
        font-size: 28px;
        text-align: left;
        height: 100%;
        line-height: 26px;
        vertical-align: middle;
        display: table-cell;
        padding: .35em;
    }

    .login {
        height: 100%;
    }

    form {
        margin: auto;
        text-align: center;
        display: inline-block;
        padding: 2em;
    }

    form input {
        border: 1px solid #ced4da;
        border-radius: .25rem;
        margin-bottom: 1.5em;
        padding: 4px;
    }

    form label {
        width: 15%;
        text-align: left;
    }

    form input,
    .btn {
        width: 80%;
    }

    .btn {
        margin-top: 1.8em;
    }

    ul {
        list-style: none;
        padding-inline-start: 0px;
    }

    .error {
        display: block;
        color: red;
        text-align: center;
    }

</style>